var console = window.console;

jQuery(function($) {

    // Nav bar - colour change on menu open
    // $('#nav-menu').on('show.bs.collapse', function () {
    //     $("#navbar").addClass("darken")
    // });
    // $('#nav-menu').on('hidden.bs.collapse', function () {
    //     $("#navbar").removeClass("darken")
    // });

    // // Nav bar - colour change on login open
    // $('#login-menu').on('show.bs.collapse', function () {
    //     $("#navbar").addClass("login-bg")
    // });
    // $('#login-menu').on('hidden.bs.collapse', function () {
    //     $("#navbar").removeClass("login-bg")
    // });

    


    // document.addEventListener('DOMContentLoaded', function() {
    //     const collapseMenus = document.querySelectorAll('[data-bs-toggle="collapse"]');
        
    //     collapseMenus.forEach(function(collapseMenu) {
    //       collapseMenu.addEventListener('click', function() {
    //         const target = this.getAttribute('data-bs-target');
    //         const allCollapseMenus = document.querySelectorAll('.collapse.show');
            
    //         allCollapseMenus.forEach(function(collapse) {
    //           if (collapse.getAttribute('id') !== target.replace("#", "")) {
    //             const bsCollapse = new bootstrap.Collapse(collapse);
    //             bsCollapse.hide();
    //           }
    //         });
    //       });
    //     });
    //   });




// VIDEO

// function checkVideosReady(videosReady) {
//   videosReady++;
//   if (videosReady === 2) {
//       playBothVideos();
//   }
// }


// $('#nav-menu').on('show.bs.collapse', function () {
//   $('body').addClass('no-scroll');
// });

// $('#nav-menu').on('hide.bs.collapse', function () {
//   $('body').removeClass('no-scroll');
// });



/**
 * 
 * @param {HTMLElement} carousel 
 * @param {string?} filter 
 */
function cardCarouselFilter(carousel, filter = null){

  let button = filter && carousel.querySelector(`.filter-buttons button[value=${filter}]`)
  let active = carousel.querySelector(".filter-buttons button.active")

  filter = (!button || button.matches(".active"))? "" : (button.classList.add("active"), filter)

  active && active.classList.remove("active")    

  carousel.querySelector(".filter-select").value = filter

  carousel.querySelectorAll(".card-carousel-item").forEach(item => item.classList.remove("d-none"))
      
  if (filter) {
      carousel.querySelectorAll(`.card-carousel-item:not([data-category=${filter}])`).forEach(item => {
          item.classList.add("d-none")
      })   
  }
  carousel.querySelector(".carousel-inner").style.setProperty("--slide", 0)
}

function cardCarouselSlide(inner, d){
  let items = inner.querySelectorAll(".card-carousel-item:not(.d-none)").length
  inner.style.setProperty("--slide", Math.max(0, Math.min(items - 1, d + +inner.style.getPropertyValue("--slide"))))
}

addEventListener("click", e => {
  let carousel = e.target.closest(".card-carousel-container")

  let inner = carousel && carousel.querySelector(".carousel-inner")
  
  if (carousel && e.target.closest(".carousel-control-prev, .carousel-control-next")){

      cardCarouselSlide(inner, e.target.closest(".carousel-control-prev")? -1 : 1)
  }

  if (e.target.matches(".card-carousel-container .filter-buttons button")){
      cardCarouselFilter(carousel, e.target.value)
  }
})

addEventListener("change", e => {
  if (e.target.matches(".card-carousel-container .filter-select")){
      cardCarouselFilter(e.target.closest(".card-carousel-container"), e.target.value)
  }
})


addEventListener("touchstart", eStart => {

  let carousel = eStart.target.closest(".card-carousel-container")

  if (!carousel) return

  let inner = carousel.querySelector(".carousel-inner")

  inner.addEventListener("touchend", eEnd => {

      cardCarouselSlide(inner, Math.sign(eStart.changedTouches[0].clientX - eEnd.changedTouches[0].clientX))

  }, {once: true})

})





    // Login menu - placeholder text
    $("#user_login").attr("placeholder", "username");
    $("#user_pass").attr("placeholder", "password");

    // Posts Page
    if ($("body").hasClass("blog")) {

        // Load posts
        function loadPosts(filters = []) {
            $.ajax({
                url: '/wp-admin/admin-ajax.php',
                type: 'POST',
                data: {
                    action: 'load_filtered_posts',
                    filters: filters
                },
                success: function(response) {
                    $('#posts-container').html(response);
                }
            });
        }
        loadPosts();

        // Update posts list when selecting filter
        $('.filter-checkbox').change(function() {
            let filters = [];
            $('.filter-checkbox:checked').each(function() {
                filters.push($(this).val());
            });
            loadPosts(filters);
        });
    } 

});